<template>
  <v-container id="scheduled-orders-pending-list-view">
    <material-card
      color="primary"
      icon="mdi-account-multiple"
    >
      <template #title>
        Pending Approval Orders
      </template>

      <scheduled-orders :show-title="false" :pending="true"></scheduled-orders>
    </material-card>
  </v-container>
</template>

<script>
export default {
  name: 'OrdersScheduledPending',
  components: {
    MaterialCard: () => import('@/components/MaterialCard'),
    ScheduledOrders: () => import('../components/ScheduledOrders')
  }
}
</script>

<style scoped>

</style>
